import React, { FC } from "react"
import { useToggle } from "../../utils/Hooks"
import { Contents } from "./Contents"
import { IModal } from "contentful-types"
import { DynamicContentComponentProps } from "./DynamicContentComponentProps"
import { Modal as ModalTemplate, Container, FlexContainer, H2, ArrowLink } from "@carrotfertility/carotene"
import styled from "styled-components"

const ContentFade = styled.div`
  position: absolute;
  bottom: 35px;
  left: 36px;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  transform: rotate(-180deg);
  height: 50px;
  width: calc(100% - 80px);
`

export const Modal: FC<DynamicContentComponentProps<IModal>> = ({ content }) => {
  const {
    fields: { linkText, content: internalContent, title }
  } = content

  const [showModal, toggleShowModal] = useToggle(false)

  return (
    <>
      <ArrowLink onClick={toggleShowModal}>{linkText}</ArrowLink>
      <ModalTemplate open={showModal} onClose={toggleShowModal} isDismissable showClose fullScreenMobile>
        <Container sx={{ paddingBottom: "large", position: "relative" }}>
          <FlexContainer
            sx={{ overflowY: "auto" }}
            direction="column"
            padding="0 0 50px 0"
            paddingLeftRight="large"
            maxHeight={["calc(100vh - 114px)", null, null, "60vh"]}
            gap="huge"
          >
            {title && <H2>{title}</H2>}
            <Contents contents={internalContent} />
          </FlexContainer>
          <ContentFade />
        </Container>
      </ModalTemplate>
    </>
  )
}
